// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:14
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class TimerScheduleResultArgs_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.TimerScheduleResultArgs';
  $t: string = 'SagaBase.Defines.TimerScheduleResultArgs';

  public static GetMembers(): string[] {
    return ['Error', 'Operations'];
  }

  public GetMembers(): string[] {
    return TimerScheduleResultArgs_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Error: SagaBase.ServerErrorType = SagaBase.ServerErrorType.None;
  public Operations: any[];

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
